/* tslint:disable */
/* eslint-disable */
/**
 * Orders and payments
 * Placeholder description of the order & payment instruction service. Detailed description to be provided by Monavate team.
 *
 * The version of the OpenAPI document: 1.33.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { IBANAccounts } from '../models';
/**
 * IBANApi - axios parameter creator
 * @export
 */
export const IBANApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all IBAN accounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listIBANAccounts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ibans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IBANApi - functional programming interface
 * @export
 */
export const IBANApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IBANApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get all IBAN accounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listIBANAccounts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IBANAccounts>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listIBANAccounts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IBANApi.listIBANAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * IBANApi - factory interface
 * @export
 */
export const IBANApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IBANApiFp(configuration)
    return {
        /**
         * 
         * @summary Get all IBAN accounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listIBANAccounts(options?: RawAxiosRequestConfig): AxiosPromise<IBANAccounts> {
            return localVarFp.listIBANAccounts(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IBANApi - object-oriented interface
 * @export
 * @class IBANApi
 * @extends {BaseAPI}
 */
export class IBANApi extends BaseAPI {
    /**
     * 
     * @summary Get all IBAN accounts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IBANApi
     */
    public listIBANAccounts(options?: RawAxiosRequestConfig) {
        return IBANApiFp(this.configuration).listIBANAccounts(options).then((request) => request(this.axios, this.basePath));
    }
}

